<template>
  <div class="marketplace main_container">
    <div v-if="user.loggedIn" class="userLoggedIn">
      <Ecosystem />
    </div>
    <div v-else class="userNotLoggedIn">
      <Landing />
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, watch } from "vue";
import Ecosystem from "@/components/DashboardComponents/Ecosystem.vue";
import Landing from "@/components/LandingComponents/Landing.vue";

export default {
  name: "Dashboard",
  components: {
    Ecosystem,
    Landing,
  },

  setup() {
    const store = useStore();
    const user = computed(() => {
      return store.getters.user;
    });

    watch(
      () => store.getters.selectedCustomOrgProjection,
      (newVal, oldVal) => {
        if (newVal) {
          const orgUID = store.getters.selectedOrgUID || store.getters.currentOrgUID;
          // console.log("ORGUID");
          // console.log(newVal[orgUID]);
          if (orgUID) {
            const monetaryParams = newVal[orgUID]?.monetary_parameters;

            if (monetaryParams) {
              const coinName = monetaryParams.coin_name || "Unit";
              const coinSymbol = monetaryParams.coin_symbol || "Ʉ";

              const payload = {
                coinName,
                coinSymbol,
              };
              // console.log("Landing: Setting monetary params:", payload);

              // for coin symbol component
              store.dispatch("updateCoinSymbol", {
                symbol: monetaryParams.coin_symbol || "Ʉ",
                name: monetaryParams.coin_name || "Unit",
              });
              // for Monetary rules
              store.commit("SET_MONETARY_PARAMS", payload);
            }
          }
        }
      },
      { immediate: true }
    );

    return { user };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.content-container {
  padding-top: 40px; /* Adjust this value to provide space below the fixed tab bar */
}

.content {
  position: absolute;
  width: calc(100% - var(--space-5));
}

</style>
